// extracted by mini-css-extract-plugin
export default {"container":"noResultFound_container__fjkS0","icon":"noResultFound_icon__+Pd-u","text":"noResultFound_text__lCoQT"};